import { useState, forwardRef } from "react";
import { useSnackbar } from 'notistack';
// next
import { useRouter } from 'next/router';
// @mui
import {
  Typography,
  Dialog,
  Container,
  Fade,
  IconButton,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// componenets
import {
  Check3WayAvailableTime,
} from '../';
import Iconify from "../../../components/Iconify";
// utils
import axios from '../../../utils/axios';


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />);

const ContentStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  marginTop: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(12),
  },
}));

export default function ReselectMeetingDialog({ meetingCount, isOpen, reloadOffer, closeDialog }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = useState(false);
  const router = useRouter();
  const { oid } = router.query;

  const reMeeting = async (times) => {
    try {
      setIsSubmit(true);
      await axios.post(`api/crews/offers/${oid}/meeting-again/`, {
        crew_3way_time_range: times,
      });
      enqueueSnackbar('저장 되었습니다');
      reloadOffer();
      setIsSubmit(false);
    } catch (err) {
      console.error(err);
      setIsSubmit(false);
    }
  };

  return (
    <Dialog open={isOpen} fullScreen TransitionComponent={Transition}>
      <Container maxWidth="md" sx={{ p: 3 }}>
        <ContentStyle>
          <Stack direction="row" justifyContent="flex-end">
          <IconButton color="inherit" edge="end" onClick={closeDialog}>
            <Iconify icon="eva:close-fill" />
          </IconButton>
          </Stack>
          <Typography variant="h4" sx={{ mb: 3 }}>
            회사와 {meetingCount ? meetingCount + 1 : 2}차 미팅 일정 잡기
          </Typography>
          <Check3WayAvailableTime
            send={reMeeting}
            isSubmitting={isSubmit}
            meetingCount={meetingCount}
          />
        </ContentStyle>
      </Container>      
    </Dialog>
  )
};
